<template>
  <div class="mask-bg" v-bind:style="'display:'+isShow">
    <div class="page-loading-box">
      <div class="loading-img"></div>
      <div class="loading-hint">Loading...</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'loadingComp',
    props: ['isShow'],
    data: function () {
      return {
        isShow: this.isShow
      }
    }
  }
</script>
<style>
  .mask-bg{
    z-index: 200;
    position:fixed;
    top:0;
    left:0;
    width: 100%;
    height:100%;
    background-color: #f0f0f0;
  }

  .page-loading-box {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 60px;
    height: 69px;
    margin-top: -35px;
    margin-left: -30px;
  }

  .loading-img {
    position: absolute;
    left: 7px;
    background: url(../../assets/img/Loading_03.gif) no-repeat;
    width: 45px;
    height: 45px;
    background-size: 45px 45px;
    margin: 0 auto 10px;
    animation: load 500ms infinite;
    -moz-animation: load 500ms infinite;
    -webkit-animation: load 500ms infinite;
    -o-animation: load 500ms infinite;
  }

  @-webkit-keyframes load {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    50% {
      -webkit-transform: rotate(90deg);
      -moz-transform: rotate(90deg);
      transform: rotate(90deg);
    }
    100% {
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      transform: rotate(180deg);
    }
  }

  @-moz-keyframes load {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      transform: rotate(0deg)
    }
    50% {
      -webkit-transform: rotate(90deg);
      -moz-transform: rotate(90deg);
      transform: rotate(90deg)
    }
    100% {
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      transform: rotate(180deg)
    }
  }

  @-o-keyframes load {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      transform: rotate(0deg)
    }
    50% {
      -webkit-transform: rotate(90deg);
      -moz-transform: rotate(90deg);
      transform: rotate(90deg)
    }
    100% {
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      transform: rotate(180deg)
    }

  }

  @keyframes load {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      transform: rotate(0deg)
    }
    50% {
      -webkit-transform: rotate(90deg);
      -moz-transform: rotate(90deg);
      transform: rotate(90deg)
    }
    100% {
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      transform: rotate(180deg)
    }
  }

  .loading-hint {
    margin: 55px 0 0 7px;
    color: #aaa;
    font-size: 12px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/commen/loading.vue